<rt-box class="job-board" variant="no-padding" padding-medium>
  <div class="logo" [style.background-image]="logoUrl"></div>
  <div [class.info-container-trial]="isTrial" class="job-board__info-container">
    <rt-heading variant="heading block">
      {{ name }}
      <a
        *ngIf="!isTrial"
        [href]="website"
        class="link color board-link"
        target="_blank"
        layout-horizontal
        layout-align-items-center
        margin-left-small-xx
      >
        <rt-icon [name]="'open-in-new'"></rt-icon>
      </a>
    </rt-heading>
    <div class="job-board__info">
      <div *ngIf="autoPostingDisabled && !isTrial && codename !== 'fashionunited'">
        <div class="posting_disabled status">
          {{ translations.postingDisabled | translate }}
          <rt-icon-help-with-dropdown
            [contactSupport]="true"
            [infoText]="translations.postingDisabledInfo | translate"
            (openIntercom)="openIntercom.emit()"
            margin-left-small-x
          >
          </rt-icon-help-with-dropdown>
        </div>
      </div>

      <div *ngIf="(!autoPostingDisabled && !isTrial) || codename === 'fashionunited'">
        <div
          [ngClass]="posting?.status || []"
          [class.published]="type === JobBoardType.Auto && posting"
          [class.pending-posting]="pendingPosting"
          [rtTooltip]="tooltipMessage"
          [rtTooltipEnabled]="!!posting"
          class="status"
        >
          {{ label }}
        </div>

        <ng-container *ngIf="posting">
          <div *ngIf="posting.status == 'error'" class="light-color">
            {{ translations.errorInfo | translate }}
          </div>

          <div *ngIf="posting.status == 'published' && posting.url">
            <a [href]="posting.url" class="link">
              {{ posting.url }}
            </a>
          </div>
        </ng-container>
      </div>

      <div *ngIf="isTrial && codename !== 'fashionunited'">
        <div class="status">
          {{ 'app.promote.publish_for_free' | translate }}
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!isTrial">
    <div *ngIf="settingsLink" layout layout-align-items-center>
      <rt-button
        variant="plain only-icon"
        [routerLink]="settingsLink.path"
        [queryParams]="settingsLink.queryParams"
      >
        <rt-icon [name]="'settings'"></rt-icon>
      </rt-button>
    </div>

    <div *ngIf="showPublish" layout layout-align-items-center>
      <rt-button variant="outline" (click)="onAddPosting()" *ngIf="codename !== 'fashionunited'">
        {{ translations.publish | translate }}
      </rt-button>

      <rt-button variant="outline" (click)="onMoreInfo()" *ngIf="codename === 'fashionunited'">
        {{ 'app.promote.more_info' | translate }}
      </rt-button>
    </div>
  </ng-container>
</rt-box>
